import React from 'react'
import PropTypes from 'prop-types'

// Material-UI
//   npm install --save material-ui
import * as mui from 'material-ui'

// 自作ユーティリティ・ツール
import * as GridUtils from '../GridUtils'
import * as def from '../define'
import * as WebAPI from '../webapi'
import { showMaintenanceDlg } from '../utils'

/**
 * 契約情報結び付
 */
export default class TenantSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      info: Object.assign({}, this.props.info),

      tenantId: '',
      adminUserId: '',
      password: '',

      tenant: null,
    }
  }

  onConfirmClick() {
    // プログレス表示
    if (typeof this.props.callbacks.showMessage === 'function') {
      this.props.callbacks.showMessage('WAIT', {})
    }

    // 契約の結び付けの確認
    WebAPI.confirmAttachContract(this.state.info.token,
      this.state.tenantId, this.state.adminUserId, this.state.password)
      .then(
        function (obj) {
          // プログレス非表示
          if (typeof this.props.callbacks.showMessage === 'function') {
            this.props.callbacks.showMessage('', {})
          }

          // 結び付け可能ならテナント情報が取得できているので、テナント情報をセット
          this.setState({ tenant: obj })
        }.bind(this)
      ).catch(
        function (err) {
          // プログレス非表示
          if (typeof this.props.callbacks.showMessage === 'function') {
            this.props.callbacks.showMessage('', {})
          }

          // エラー処理
          if (WebAPI.checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
            // メンテナンス中
            const endTime = err.response.body.maintenanceEndTime
            showMaintenanceDlg(this.props.callbacks.showMessage, endTime, true)
            return
          }

          if (typeof this.props.callbacks.showMessage === 'function') {
            if (err.status === 400) {
              this.props.callbacks.showMessage('MSGBOX', { msgTitle: 'エラー', msgBody: JSON.parse(err.response.text).message, forceLogout: false })
            } else {
              this.props.callbacks.showMessage('APIERR', { msgBody: '\n' + err.status + '\n' + JSON.parse(err.response.text).message, forceLogout: false })
            }
          }
        }.bind(this)
      )
  }

  onEntryClick() {
    // プログレス表示
    if (typeof this.props.callbacks.showMessage === 'function') {
      this.props.callbacks.showMessage('WAIT', {})
    }

    // 契約の結び付け
    WebAPI.attachContract(this.state.info.token,
      this.state.tenantId, this.state.adminUserId, this.state.password)
      .then(
        function (obj) {
          // プログレス非表示
          if (typeof this.props.callbacks.showMessage === 'function') {
            this.props.callbacks.showMessage('', {})
          }

          // 完了画面の表示に必要な情報をセットして、次のステップへ
          let info = this.state.info
          info.contractId = obj.tenant.tenantName
          info.adminId = obj.adminUser.userName
          info.adminName = obj.adminUser.displayName
          info.adminMailAddress = obj.adminUser.email

          if (typeof this.props.callbacks.stepChange === 'function') {
            this.props.callbacks.stepChange(info, def.STEPS.ENTRY_COMPLETE)
          }
        }.bind(this)
      ).catch(
        function (err) {
          // プログレス非表示
          if (typeof this.props.callbacks.showMessage === 'function') {
            this.props.callbacks.showMessage('', {})
          }

          // エラー処理
          if (WebAPI.checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
            // メンテナンス中
            const endTime = err.response.body.maintenanceEndTime
            showMaintenanceDlg(this.props.callbacks.showMessage, endTime, true)
            return
          }

          if (typeof this.props.callbacks.showMessage === 'function') {
            if (err.status === 400) {
              this.props.callbacks.showMessage('MSGBOX', { msgTitle: 'エラー', msgBody: JSON.parse(err.response.text).message, forceLogout: false })
            } else {
              this.props.callbacks.showMessage('APIERR', { msgBody: '\n' + err.status + '\n' + JSON.parse(err.response.text).message, forceLogout: false })
            }
          }
        }.bind(this)
      )
  }

  onCancelClick() {
    if (typeof this.props.callbacks.logout === 'function') {
      this.props.callbacks.logout()
    }
  }

  render() {
    const styles = {
      label: { margin: '0px' },
      paper: { height: '8rem', marginTop: '20px', padding: '10px' }
    }

    // テナント情報を作成
    let tenantInfo = null
    if (this.state.tenant !== null) {
      let companyName = ''
      this.state.tenant.companies.forEach(function (c, i) {
        if (i < 3) {
          // 3個までは会社名をつなげる
          companyName += (i !== 0 ? '、' : '') + c.displayName
        } else if (i === 3) {
          // 4個目からは省略
          companyName += '…'
        }
      })
      tenantInfo = <div>
        <p style={styles.label}>{'管理者名：' + this.state.tenant.adminUser.displayName}</p>
        <p style={styles.label}>{'登録メールアドレス：' + this.state.tenant.adminUser.email}</p>
        <p style={styles.label}>{'会社：' + companyName}</p>
      </div>
    }

    return (
      <div className='AppContent'>
        <div style={{ width: '800px', textAlign: 'left', marginLeft: 'auto', marginRight: 'auto' }}>
          <div className='GroupPane' style={GridUtils.GridColumns('6rem 300px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 3)}>
              {'契約情報の結び付け'}
            </h2>
            <p className={'EntryItem'} style={GridUtils.GridPosStyleWithColspan(2, 1, 3)}>
              {'結び付けたい契約情報のIDとパスワードを入力し、「確　認」ボタンを押してください。'}
            </p>
            <mui.TextField className={'EntryItem'} style={GridUtils.GridPosStyle(3, 1, 2)}
              type='text'
              floatingLabelText='契約ID'
              value={this.state.tenantId}
              onChange={e => this.setState({ tenantId: e.target.value })} />
            <mui.TextField className={'EntryItem'} style={GridUtils.GridPosStyle(4, 1, 2)}
              type='text'
              floatingLabelText='管理者ID'
              value={this.state.adminUserId}
              onChange={e => this.setState({ adminUserId: e.target.value })} />
            <mui.TextField className={'EntryItem'} style={GridUtils.GridPosStyle(5, 1, 2)}
              type='password'
              floatingLabelText='パスワード'
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })} />
            <button className={'EntryItem'} style={GridUtils.GridPosStyle(6, 1)}
              type='button'
              disabled={this.state.tenantId.length === 0 || this.state.adminUserId.length === 0 || this.state.password.length === 0}
              onClick={() => this.onConfirmClick()}>
              {'確　認'}
            </button>
          </div>
          <div className='GroupPane' style={GridUtils.GridColumns('600px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 2)}>
              {'契約情報の確認'}
            </h2>
            <div style={GridUtils.GridPosStyleWithColspan(2, 1)}>
              <mui.Paper style={styles.paper}>
                {tenantInfo}
              </mui.Paper>
            </div>
            <p className={'EntryItem'} style={GridUtils.GridPosStyleWithColspan(3, 1, 2)}>
              {'この契約情報と結び付ける場合は、「登　録」ボタンを押してください。'}
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <button type='button'
              disabled={this.state.tenant === null}
              onClick={() => this.onEntryClick()}>
              {'登　録'}
            </button>
            <button type='button' style={{ margin: '0 40px' }}
              onClick={() => this.onCancelClick()}>
              {'中　止'}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

TenantSelect.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/connectTenant.js